import { Capacitor } from '@capacitor/core';

export const combineApiURL = (): string => {
  const protocol = window.location.protocol;
  const apiUrl = process.env.REACT_APP_API_URL === 'localhost'
                 ? window.location.host
                 : process.env.REACT_APP_API_URL;
  const hostname = Capacitor?.isNative
                   ? process.env.REACT_APP_MOBILE_HOST
                   : apiUrl;

  return `${protocol}//${hostname}`;
};

export default combineApiURL;
